module.exports = __webpack_public_path__ + "static/media/13.01c6f7ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/scene0/asset/13.png
// module id = 1764
// module chunks = 0